import { useEffect, useContext } from "react";
import { CartContext } from "../context/CartContext";

function Success() {
  const { clearCart } = useContext(CartContext);

  // Clear cart when the component mounts
  // This ensures the cart is cleared after a successful order
  useEffect(() => {
    clearCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-container" style={{ textAlign: "left", marginTop: "3rem" }}>
      <h2>Success!</h2>
      <p>Your order has been placed.</p>
      <p>You will receive an email with shipping info within the next week.  Feel free to reach out at <b>contact@owen.studio</b> if you have any questions!</p>
    </div>
  );
}

export default Success;